import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LibSubContractorsPaymentsDto } from './lib-sub-contractors-payments-dto';

export class SubContractorsPaymentsResponseModel extends GlobalResponseObject{
    data?: LibSubContractorsPaymentsDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LibSubContractorsPaymentsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        // this.data = data;
    }
}
